import styled from "styled-components";
import { _ } from "@sablier/v2-mixins";
import { useWatcher } from "../logic";
import Fields from "./fields";

const WrapperPartial = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    row-gap: calc(${(props) => props.theme.sizes.edge});
    width: 100%;
    *[data-component="box"] {
      background: ${(props) => props.theme.colors.dark050};
    }

    & > *[data-locked="true"] {
      *[data-component="box"] {
        background: ${(props) => props.theme.colors.dark050};
      }
    }
  }
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxMD} {
    max-width: calc(100vw - ${(props) => props.theme.sizes.edge} * 2);
    & > * {
      width: 100%;
      max-width: 100%;
    }
  }
`;

function Form() {
  useWatcher();

  return (
    <Wrapper>
      <Fields.Token />
      <Fields.Amount />
    </Wrapper>
  );
}

export default Form;
